import { describe } from '@elliemae/ds-props-helpers';
import { DSAccordion, DSAccordionItem } from '@elliemae/ds-accordion';
import type { DSAccordionT } from '@elliemae/ds-accordion';
import { mobileAccordionItemPropTypes, mobileAccordionPropTypes } from './react-desc-prop-types.js';

type DSMobileAccordionPropsT = Omit<DSAccordionT.Props, 'isDSMobile'>;

export const DSMobileAccordion = ({ children, ...props }: DSMobileAccordionPropsT) => (
  <DSAccordion {...props} isDSMobile>
    {children}
  </DSAccordion>
);

export const DSMobileAccordionItem = ({ children, ...props }: DSAccordionT.ItemProps) => (
  <DSAccordionItem {...props}>{children}</DSAccordionItem>
);

DSMobileAccordionItem.displayName = 'DSMobileAccordionItem';
const DSMobileAccordionItemWithSchema = describe(DSMobileAccordionItem);
DSMobileAccordionItemWithSchema.propTypes = mobileAccordionItemPropTypes;

DSMobileAccordion.displayName = 'DSMobileAccordion';
const DSMobileAccordionWithSchema = describe(DSMobileAccordion);
DSMobileAccordionWithSchema.propTypes = mobileAccordionPropTypes;

export { DSMobileAccordionItemWithSchema, DSMobileAccordionWithSchema };
